var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-checkbox',{directives:[{name:"show",rawName:"v-show",value:(typeof _vm.value === 'boolean'),expression:"typeof value === 'boolean'"}],attrs:{"value":_vm.value,"disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }